import type { ComparableCategoryId } from './types';

export const API_BASE_URL = import.meta.env?.VITE_DEFAULT_API_BASE_URL as string;
export const PLAN_API_BASE_URL = import.meta.env?.VITE_PLAN_API_URL as string;
export const SIGN_UP_URL = 'https://app.lickd.co/sign-up';
/** Our plans are only available to ratecards up to 5m AVV */
export const RECOMMENDED_PLAN_MAX_AVV = 4999999;

/** Icon shown alongside each comparable's category label. See WEB-11513. */
export const CATEGORY_ICONS: Record<ComparableCategoryId, string> = {
  'power-user': '⚡',
  'content-machine': '🎬',
  'regular-user': '💪',
  'conversation-starter': '🔥',
  'mainstream-reach': '🌎',
  'consistent-creator': '📅',
  'early-adopter': '🎸',
  'lickd-creator': '✨',
};

/** To be kept aligned with MAX_CREDIBLE_UPLIFT in crescendo-api */
export const MAX_CREDIBLE_UPLIFT = 1000;
